import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService } from '../../_services';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { PaymentsStore } from '../../_services/store';
import { UpgradeStore } from '../../_services/store/upgradeStore.service';

@Component({
  selector: 'app-select-payment-method',
  templateUrl: './select-payment-method.page.html',
  styleUrls: ['./select-payment-method.page.scss'],
})
export class SelectPaymentMethodPage implements OnInit {
  types = [];
  title: string;
  path: string;
  selectedType: string;
  subscription: any;

  constructor(
    private router: Router,
    private location: Location,
    private platform: Platform,
    private alertService: AlertService,
    private paymentsStore: PaymentsStore,
    private upgradeStore: UpgradeStore,
    private closeOverlayService: CloseOverlayService
  ) { }

  dismissModal() {
    this.alertService.dismissModal();
  }

  selectType(selectedType: any) {
    this.dismissModal();
    this.selectedType = selectedType;
    if (this.selectedType === this.types[0]) {
      if (this.path.includes('payment')) {
        this.paymentsStore.setPaymentMethod('bankTransfer');
      } else {
        this.upgradeStore.setIsBusinessRegistered(true);
      }
    } else if (this.selectedType === this.types[1]) {
      if (this.path.includes('payment')) {
        this.paymentsStore.setPaymentMethod('ussd');
      } else {
        this.upgradeStore.setIsBusinessRegistered(false);
      }
    }
  }

  ionViewDidEnter() {
    this.path = window.location.pathname;
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      if (this.constructor.name === 'SelectPaymentMethodPage' && this.path.includes('payment')) {
        this.closeOverlayService.trigger();
        this.router.navigate(['/new-payment']);
      } else {
        this.location.back();
      }
    });
    if (this.path.includes('payment')) {
      this.title = 'Payment Method';
      this.types.push('Bank Transfer', 'USSD');
    } else if (this.path.includes('gold')) {
      this.title = 'Business Category';
      this.types.push(
        'Registered (CAC Certificate required)',
        'Not Registered');
    }
  }

  ngOnInit() {
  }

}
